import { render, staticRenderFns } from "./DictDialog.vue?vue&type=template&id=b6baa508"
import script from "./DictDialog.vue?vue&type=script&lang=js"
export * from "./DictDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports